import React from "react";

const Gift = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.56 4.1C16.8984 3.7256 17.1 3.2576 17.1 2.74928C17.1 1.5224 15.853 0.5 14.4 0.5C12.0427 0.5 10.5653 1.86512 9.90287 2.85584C9.23903 1.86512 7.75728 0.5 5.4 0.5C3.94704 0.5 2.7 1.5224 2.7 2.75072C2.7 3.2576 2.90016 3.7256 3.24 4.10144H0V9.5H0.899999V16.7C3.47616 17.8347 6.5664 18.5029 9.89999 18.5C13.2336 18.4971 16.3253 17.839 18.9 16.7V9.5H19.8V4.1H16.56ZM5.6376 2.04368C7.99344 2.04368 9 4.1 9 4.1H5.6376C5.01408 4.1 4.50864 3.6176 4.50864 3.05744C4.50864 2.49728 5.01408 2.04368 5.6376 2.04368ZM7.2 16.5517C5.6088 16.376 4.09824 16.0448 2.7 15.5869V9.5H7.2V16.5517ZM7.2 7.7H1.8V5.9H7.2V7.7ZM10.8 16.6813C10.5019 16.6928 10.2024 16.7 9.89999 16.7H9.89423C9.59327 16.7 9.29664 16.6928 9 16.6827V5.9H10.8V16.6813ZM14.1797 2.04368C14.8032 2.04368 15.3086 2.49728 15.3086 3.05888C15.3086 3.62048 14.8032 4.10144 14.1797 4.10144H10.8C10.8 4.10144 11.8238 2.04368 14.1797 2.04368ZM17.1 15.5869C15.7032 16.0448 14.1912 16.3731 12.6 16.5488V9.5H17.1V15.5869ZM18 7.7H12.6V5.9H18V7.7Z'
        fill={fill}
      />
    </svg>
  );
};

Gift.defaultProps = {
  width: 20,
  height: 19,
  fill: "#0FAF4B",
};

export default Gift;
